import { useEffect, useState } from "react";

import { AtRegularV6 } from "@shared/v2/Icomoon";
import { tryCatchHandlr } from "@shared/Utilities";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";

const personAPI = (uuid, param) => `/api/v4/activity_feed/person_name?${param}=${uuid}`;
const transactionAPI = (uuid) => `/api/v4/transactions/header/${uuid}`;

const NoteMentionActivity = ({ activity, onReadChange }) => {
  const isPerson = activity.data.notableType === "Person";
  const queryParams = new URLSearchParams();

  if (!isPerson) {
    queryParams.set("tab", "notes");
  }

  const [notableName, setNotableName] = useState(null);

  useEffect(() => {
    (async () => {
      const notableAPI = isPerson ? personAPI : transactionAPI;

      const [resNotableName, errNotableName] = await tryCatchHandlr(
        caseTransformingAxios.get(`${notableAPI(activity.data.notableId, "person_uuid")}`, {
          authenticity_token: ReactOnRails.authenticityToken(),
        }),
      );

      if (errNotableName) throw errNotableName;

      setNotableName(resNotableName.data.name || resNotableName.data.address?.streetAddress);
    })();
  }, [activity]);

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]" Icon={AtRegularV6}>
            Note Mention
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField label="Added To" data={notableName === null ? "" : notableName || "No Name"} />
        <span className={STYLES.lineClamp3}>{activity.data.note}</span>
      </div>
    </ActivityContainer>
  );
};

export default NoteMentionActivity;

NoteMentionActivity.propTypes = {
  ...activityCommonPropTypes,
};

NoteMentionActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
